import { useState, type ReactNode } from 'react'
import FsLightbox from 'fslightbox-react'

export interface VideoLightboxProps {
  /** Video URL, e.g. a YouTube link. */
  source: string
  children: ReactNode
  /** Value of the `data-fslightbox` group attribute. */
  group?: string
  className?: string
}

/**
 * Opens a video in a lightbox. Used on the Service Details page.
 *
 * The anchor keeps its `href` and `data-fslightbox` attributes so the CSS selectors
 * still apply; the click is intercepted rather than followed. `FsLightbox` renders
 * into a portal only while open, so the at-rest DOM stays clean.
 */
export function VideoLightbox({ source, children, group = 'Video', className }: VideoLightboxProps) {
  const [toggler, setToggler] = useState(false)

  return (
    <>
      <a
        href={source}
        data-fslightbox={group}
        {...(className ? { className } : {})}
        onClick={(e) => {
          e.preventDefault()
          setToggler((v) => !v)
        }}
      >
        {children}
      </a>
      <FsLightbox toggler={toggler} sources={[source]} />
    </>
  )
}
